import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { ErrorService } from 'src/app/services/error.service';
import { environment } from 'src/environments/environment';
import * as E9EktosActions from '../actions/e9Ektos.actions';
import { AppState } from '../app.reducer';
import { QueryParamsModel } from 'src/app/utils/query-params.model';
import { IEktosSxediou } from 'src/app/core/models/e9_ektos_sxediou.model';

@Injectable()
export class E9EktosEffects {
    constructor(
        public actions$: Actions,
        public http: HttpClient,
        private errorService: ErrorService,
        private store: Store<AppState>
    ) { }
    payloadReload;

    getE9Ektos$ = createEffect(() =>
        this.actions$.pipe(
            ofType(E9EktosActions.gete9Ektos),
            switchMap((payload) => {
                const query = { ...payload.payload, filters: JSON.stringify(payload.payload.filters) };
                this.store.dispatch(E9EktosActions.e9EktosLoading({ payload: { loading: true } }));
                this.payloadReload = payload.payload;
                const queryPayload = {
                    filters: query.filters,
                    sortOrder: query.sortOrder,
                    sortField: query.sortField,
                    pageNumber: query.pageNumber.toString(),
                    pageSize: query.pageSize.toString(),
                };
                return this.http
                    .get<{ data: IEktosSxediou[]; query: QueryParamsModel; totalCount: number }>(
                        environment.apiUrl + '/e9Ektos',
                        {
                            params: queryPayload,
                        }
                    )
                    .pipe(
                        switchMap((responseData) => {
                            this.store.dispatch(
                                E9EktosActions.gete9EktosSuccess({
                                    payload: {
                                        properties: responseData.data,
                                        totalCount: +responseData.totalCount
                                    },
                                })
                            );
                            return of(E9EktosActions.e9EktosLoading({ payload: { loading: false } }));
                        }),
                        catchError((error) => {
                            this.store.dispatch(
                                E9EktosActions.e9EktosFail({ payload: { error: this.errorService.mapError(error) } })
                            );
                            return of(E9EktosActions.e9EktosLoading({ payload: { loading: false } }));
                        })
                    );
            })
        )
    );

    updateE9Ektos$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(E9EktosActions.updateE9Ektos),
            switchMap(({ payload }) => {
                this.store.dispatch(
                    E9EktosActions.e9EktosLoading({ payload: { loading: true } })
                );
                return this.http
                    .put<null>(
                        environment.apiUrl + `/e9Ektos/${payload.entity.id}`,
                        payload
                    )
                    .pipe(
                        switchMap(() => {
                            return of(
                                E9EktosActions.e9EktosUpdated({ payload: { entity: payload.entity } }),
                                E9EktosActions.e9EktosLoading({ payload: { loading: false } })
                            );
                        }),
                        catchError((error) => {
                            return of(
                                E9EktosActions.e9EktosFail({
                                    payload: { error: this.errorService.mapError(error) },
                                })
                            );
                        })
                    );
            })
        );
    });


    deleteE9Ektos$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(E9EktosActions.deleteE9Ektos),
            switchMap(({ payload }) => {
                this.store.dispatch(
                    E9EktosActions.e9EktosLoading({ payload: { loading: true } })
                );
                return this.http
                    .delete<null>(
                        environment.apiUrl + `/e9Ektos/` + payload.entity.id,
                    )
                    .pipe(
                        switchMap(() => {
                            return of(
                                E9EktosActions.e9EktosDeleted({ payload: { entity: payload.entity } }),
                                E9EktosActions.e9EktosLoading({ payload: { loading: false } })
                            );
                        }),
                        catchError((error) => {
                            return of(
                                E9EktosActions.e9EktosFail({
                                    payload: { error: this.errorService.mapError(error) },
                                })
                            );
                        })
                    );
            })
        );
    });

    getE9EktosKaek$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(E9EktosActions.getE9EktosKaek),
            switchMap(({ payload }) => {
                this.store.dispatch(
                    E9EktosActions.e9EktosLoading({ payload: { loading: true } })
                );
                return this.http
                    .get<IEktosSxediou>(
                        `${environment.apiUrl}/e9Ektos/${encodeURIComponent(payload.kaekValue)}`
                    )
                    .pipe(
                        mergeMap((e9Ektos) => [
                            E9EktosActions.getE9EktosKaekSuccess({ payload: { e9Ektos } }),
                            E9EktosActions.e9EktosLoading({ payload: { loading: false } })
                        ]),
                        catchError((error) => {
                            return of(
                                E9EktosActions.getE9EktosKaekFail({
                                    payload: { error: this.errorService.mapError(error) },
                                })
                            );
                        })
                    );
            })
        );
    });

}
